import React from 'react'
import Typography from '@material-ui/core/Typography'

import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'

import style from './style'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'

import { useHistory } from 'react-router-dom'
import axios from '../../Services/axios'
import { useState } from 'react'
import { useEffect } from 'react'
import Swal from 'sweetalert2'

export default function ConselhoTutelar(){
    const classes = style()
    const [conselhos, setConselhos] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    
    useEffect(() => {
        axios
            .get("conselhoTutelar")
            .then(({data}) => {
                setConselhos(data.data)
                setIsLoading(false)
            })
    }, [])

    const history = useHistory()
    return (
        <div>
            <Typography className={classes.title} variant="h1" >Cadastro de Conselho Tutelar</Typography>

            <div className={classes.containerButton}>
                <Button variant="contained" color="primary" onClick={() => {
                    history.push("conselho/cadastrar")
                }}>
                  Criar novo
                </Button>
            </div>

            <TableContainer>
                <Table className={classes.table} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center">Nome</TableCell>
                            <TableCell align="center">Cidade</TableCell>
                            <TableCell align="center">Estado</TableCell>
                            <TableCell align="center"></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            isLoading? (
                                <TableRow>
                                    <TableCell>Carregando...</TableCell>
                                </TableRow>
                            ): null
                        }
                        {
                            conselhos.map((row) => (
                                <TableRow key={row.id}>
                                    <TableCell>{row.nome}</TableCell>
                                    <TableCell>{row.cidade}</TableCell>
                                    <TableCell>{row.estado}</TableCell>
                                    <TableCell>
                                        <IconButton aria-label="" onClick={() => {
                                            Swal.fire({
                                                title: 'Tem certeza que deseja excluir?',
                                                text: "Você não poderá desfazer esta ação!",
                                                icon: 'warning',
                                                showCancelButton: true,
                                                confirmButtonColor: '#3085d6',
                                                cancelButtonColor: '#d33',
                                                confirmButtonText: 'Sim!'
                                            }).then((result) => {
                                                if (result.value) {
                                                    axios
                                                        .delete(`conselhoTutelar/${row.id}`)
                                                        .then(() => {
                                                            const newConselhos = conselhos.filter(conselho => conselho.id !== row.id)
                                                            setConselhos(newConselhos)
                                                            Swal.fire(
                                                              'Excluído!',
                                                              'Registro excluído com sucesso..',
                                                              'success'
                                                            )
                                                        })
                                                        .catch(err => {
                                                            console.log(err)
                                                            Swal.fire("Falha ao excluir. Tente novamente.")
                                                        })
                                                }
                                            })
                                        }}>
                                            <DeleteIcon color="error" />
                                        </IconButton>
                                        <IconButton aria-label="" onClick={() => {
                                            history.push(`/conselho/${row.id}/editar`)
                                        }}>
                                            <EditIcon color="action" />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            )) 
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    )
}